import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Card, Button } from '@salesforce/design-system-react';

import PersonaCarousel from './PersonaCarousel';
import CustomPersona from './CustomPersona';
import { addToast, addPersonaDBOnly, editPersonaDBOnly } from '../../actions';
import CustomToastContainer from '../App/CustomToastContainer';
import { socket } from '../../socket';

const CustomModal = (props) => {
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [hero, setHero] = useState(false);
  const [picUrl, setPicUrl] = useState('');

  useEffect(() => { 
    socket.emit('onLoadServer', props.journeyId);   
  }, []);

  useEffect(() => { 
    if(props.editing && props.personaId !== undefined && props.personaId !== '') {
      setName(props.personas[props.personaId].name);
      setRole(props.personas[props.personaId].role);
      setHero(props.personas[props.personaId].hero);
      setPicUrl(props.personas[props.personaId].picUrl);
    }
  }, []);

  useEffect(() => { 
    if (props.personaId != null) {
      setName(props.personas[props.personaId].name);
      setRole(props.personas[props.personaId].role);
      setHero(props.personas[props.personaId].hero);
      setPicUrl(props.personas[props.personaId].picUrl);
    }
  }, [props.personaId]);

  /**
   *
   *  Functions used within the CustomPersona Component
   *
   */
  const updatePicture = (event, data) => {
    event.preventDefault();
    let images = document.getElementsByClassName('slds-carousel__image');

    for (let i = 0; i < images.length; i++) {
      images[i].firstChild.classList.remove('selected-persona');
    }
    event.target.classList.add('selected-persona');

    setPicUrl(data.item.src);
  };

  const handleSave = async () => {
    if (props.editing) {
      await props.editPersonaDBOnly(props.journeyId, props.personaId, name, role, hero, picUrl);
    } else {
      await props.addPersonaDBOnly(props.journeyId, name, role, hero, picUrl);

      setName('');
      setRole('');
      setHero(false);
      setPicUrl('');
    }
  };

  const createPersona = () => {
    if (name !== '' && role !== '' && picUrl !== '') {
      handleSave();
    } else {
      props.addToast({
        labels: {
          heading:
            'Please make sure your persona has a name, role and picture.',
        },
        variant: 'error',
      });
    }
  };

  return (
    <Card hasNoHeader>
      <CustomToastContainer />
      <div className="slds-m-horizontal_medium">
        <div className="slds-grid slds-m-vertical_medium">
          <div className="slds-size_1-of-3">
            <PersonaCarousel
              onPicSelect={updatePicture}
              picUrl={picUrl}
              personaId={props.personaId}
            />
          </div>
          <div className="slds-size_2-of-3">
            <CustomPersona
              updateName={(e) => setName(e.currentTarget.value)}
              updateRole={(e) => setRole(e.currentTarget.value)}
              updateHero={(e) => setHero(e.target.checked)}
              updatePicUrl={(url) => setPicUrl(url)}
              name={name}
              role={role}
              hero={hero}
              picUrl={picUrl}
              onClick={createPersona}
              editing={props.editing}
            />
          </div>
        </div>
      </div>
    </Card>
  );
}

const mapStateToProps = (state) => ({
  journeyId: state.app.journeyId,
  personas: state.personas,
});

const mapDispatchToProps = (dispatch) => ({
  addToast: (toast) => dispatch(addToast(toast)),

    // -- ADD PERSONA START -- 
    addPersonaDBOnly : (journeyId, name, role, hero, picUrl) =>
    dispatch(addPersonaDBOnly(journeyId, name, role, hero, picUrl)),
    // -- ADD PERSONA START --

    // -- EDIT PERSONA START --
    editPersonaDBOnly : (journeyId, id, name, role, hero, picUrl) =>
    dispatch(editPersonaDBOnly(journeyId, id, name, role, hero, picUrl)),
    // -- EDIT PERSONA START --
});

CustomModal.propTypes = {
  journeyId: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  persona: PropTypes.shape({
    name: PropTypes.string,
    role: PropTypes.string,
    hero: PropTypes.bool,
    picUrl: PropTypes.string,
  }),
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomModal);
